import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultSale = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
